<template>
    <div>
        <b-button variant="default" class="mr-1" @click="showEditModal">
            <font-awesome-icon :icon="['fas', 'pen-to-square']" />
        </b-button>
        <edit-property-template-settings-modal
            :title="editPropertyTemplateSettingsModalTitle"
            :initValues="values"
            :modalId="editPropertyTemplateSettingsModalId"
            @submit="editPropertyTemplateSettings"
        />
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import Modal from '../../generic/modal/modal.vue';
    import BusyModal from '../../generic/busy-modal/busy-modal.vue';
    import FormInput from '../../generic/form-input/form-input.vue';
    import FormCheckbox from '../../generic/form-checkbox/form-checkbox.vue';
    import FormDatepicker from '../../generic/form-datepicker/form-datepicker.vue';
    import FormSelect from '../../generic/form-select/form-select.vue';
    import EditPropertyTemplateSettingsModal from './edit-property-template-settings-modal.vue';
    import { templatesMixin } from '../mixins/templates-mixin';

    export default {
        components: {
            Modal,
            BusyModal,
            FormInput,
            FormDatepicker,
            FormCheckbox,
            FormSelect,
            EditPropertyTemplateSettingsModal,
        },
        mixins: [templatesMixin],
        data() {
            return {
                editMode: false,
                values: null,
                removeTemplateModalOpened: false,
            };
        },
        computed: {
            editPropertyTemplateSettingsModalId() {
                return 'edit-property-template-settings' + this.params.data.id;
            },
            editPropertyTemplateSettingsModalTitle() {
                return 'Edit template settings';
            },
        },
        methods: {
            ...mapActions('seasonality', ['savePropertyTemplateSettings']),
            showEditModal() {
                this.values = this.getInitialValues();
                this.$bvModal.show(this.editPropertyTemplateSettingsModalId);
            },
            async editPropertyTemplateSettings(values) {
                this.$bvModal.hide(this.editPropertyTemplateSettingsModalId);
                this.busy = true;
                try {
                    await this.savePropertyTemplateSettings(values);
                    await this.fetchPropertyTemplateSettings();
                    this.successToast({
                        text: 'Property template settings updated',
                    });
                } catch (err) {
                    this.errorToast({
                        text: 'Error while updating property template settings :' + ' ' + err.response?.data.detail,
                    });
                } finally {
                    this.busy = false;
                }
            },
            getInitialValues() {
                const values = JSON.parse(JSON.stringify(this.params.data));
                return {
                    bedrooms: values.bedrooms || 0,
                    id: values.id || null,
                    name: values.name || '',
                    order: values.order || 0,
                    property_id: values.property_id || null,
                    weekend_rate: values.weekend_rate || '0.00',
                    weekly_rate: values.weekly_rate || '0.00',
                    monthly_rate: values.monthly_rate || '0.00',
                    daily_rate: values.daily_rate || '0.00',
                    extra_person_rate: values.extra_person_rate || '0.00',
                    seasonality_template_selected: values.template.id || -1,
                    template: {
                        id: values.template.id || -1,
                        name: values.template.name || 'Not set',
                    },
                };
            },
        },
    };
</script>
